import React from "react";
import { Link } from "react-router-dom";
import useTranslationHook from "../hooks/useTranslationHook";
import { useTheme } from "../../context/ThemeContext";

const UnderReview = () => {
    const { t } = useTranslationHook();
    const { assets } = useTheme();

    return (
        <section className="verify-process-wrap">
            <div className="container py-5">
                <div className="row justify-content-md-center">
                    <div
                        className="col-lg-6 wow fadeInUp"
                        data-wow-delay="0.5s"
                    >
                        <div className="verify-box ">
                            <div className="payment-check center mb-3">
                                <img
                                    src={assets.reviewIcon}
                                    alt="Payment Check"
                                />
                            </div>
                            <h4 className="display-4 mb-4 center">
                                {t("Verification Under Review")}
                            </h4>
                            {/* <p className="text mb-5 center">
                                {t("Document Under Review")}
                            </p> */}
                            <p className="sky-text text-center">
                                {t(
                                    "Your documents are being reviewed. This may take up to [expected time, e.g., 24 hours]. We’ll notify you once your account is verified"
                                )}
                            </p>
                            <div className="center">
                                <Link
                                    to="/"
                                    className="btn btn-primary btn-lg width50"
                                >
                                    {t("Return to Homescreen")}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UnderReview;
